// extracted by mini-css-extract-plugin
export default {"container":"NavSynod_container__nV8u8","back":"NavSynod_back__WEz2z","logoutBtn":"NavSynod_logoutBtn__JVL4n"};